import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import { EFAppIcon } from '@/components/UI/svg/ecoflowApp';
import { URL } from '@/constants';

const { APP_ANDROID, APP_IOS, APK_OVERSEAS, APK_CN, APP_IOS_CN, APP_IOS_RU } = URL;

const IOS_LINK: any = {
    us: APP_IOS,
    cn: APP_IOS_CN,
    cis: APP_IOS_RU,
};

export default function I() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('poweroceanapp');
    const { locale } = useRouter();

    const getAppDataLayer = (type: string) => {
        return {
            event: 'uaEvent',
            event_name: 'ecoflow_app',
            button_name: type,
        };
    };

    return (
        <div className={`ef-app-pc-i ${css.efAppPCI}`}>
            <div className="down-wrapper">
                <div className="left">
                    <p className="title">{t('sec9_title')}</p>
                    <p className="desc">{t('sec9_desc')}</p>
                    <div className="channel">
                        <div className="apple-store store">
                            <Link href={IOS_LINK[locale] || IOS_LINK.us} dataLayer={getAppDataLayer('App Store')}>
                                <NextImage
                                    webpSrc={require('@publicLocal/power-ocean/app/pc/apple-store.webp')}
                                    src={require('@publicLocal/power-ocean/app/pc/apple-store.png')}
                                    alt={t('sec9_apple_store')}
                                    aria-label={t('sec9_apple_store')}
                                />
                            </Link>
                            <p className="text">{t('sec9_apple_store')}</p>
                        </div>
                        <div className="google-play store">
                            <Link href={APP_ANDROID} dataLayer={getAppDataLayer('Google Play')}>
                                <NextImage
                                    webpSrc={require('@publicLocal/power-ocean/app/pc/google-play.webp')}
                                    src={require('@publicLocal/power-ocean/app/pc/google-play.png')}
                                    alt={t('sec9_google_play')}
                                    aria-label={t('sec9_google_play')}
                                />
                            </Link>
                            <p className="text">{t('sec9_google_play')}</p>
                        </div>
                        <div className="qrcode">
                            <EFAppIcon />
                            <p className="text">{t('sec9_qrcode')}</p>
                        </div>
                    </div>
                    <div className="link-wrapper">
                        <Link
                            className="btn"
                            href="https://portal.ecoflow.com/user/eu"
                            ariaLabel={t('sec9_title')}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_product',
                                product_name: 'EcoFlow PowerOcean',
                                list_name: t('sec9_title'),
                                button_name: t('sec9_btn'),
                            }}
                        >
                            {t('sec9_btn')}
                            <EFAppArrow className="arrow-icon" width="12px" height="12px" />
                        </Link>
                        <p className="tips">
                            {t.rich('sec9_fail_tips', {
                                blue: (text: any) => (
                                    <Link
                                        href={locale === 'cn' ? APK_CN : APK_OVERSEAS}
                                        selfWin
                                        dataLayer={getAppDataLayer('Download the EcoFlow App apk file')}
                                    >
                                        <span className="blue">{text}</span>
                                    </Link>
                                ),
                            })}
                        </p>
                    </div>
                </div>
                <div className="right">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/app/pc/9-1.webp')}
                        src={require('@publicLocal/power-ocean/app/pc/9-1.png')}
                        alt={t('sec9_title')}
                        aria-label={t('sec9_title')}
                    />
                </div>
            </div>
            <div className="goto-home">
                <NextImage
                    webpSrc={require('@publicLocal/power-ocean/app/pc/9-2.webp')}
                    src={require('@publicLocal/power-ocean/app/pc/9-2.png')}
                    alt={t('sec10_title')}
                    aria-label={t('sec10_title')}
                />
                <div className="text-wrapper">
                    <p className="title-i">{t('sec10_title')}</p>
                    <Link
                        className="more-link"
                        href="/home-battery/PowerOcean"
                        ariaLabel={t('sec10_title')}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'select_product',
                            product_name: 'EcoFlow PowerOcean',
                            list_name: t('sec10_title'),
                            button_name: t('sec10_learn_more'),
                        }}
                    >
                        {t('sec10_learn_more')}
                        <EFAppArrow className="arrow-icon" width="12px" height="12px" />
                    </Link>
                </div>
            </div>
        </div>
    );
}
